// extracted by mini-css-extract-plugin
export var coverImage = "ProgressiveImage-module--coverImage--27676";
export var coverImageMobile = "ProgressiveImage-module--coverImageMobile--84fa3";
export var loaded = "ProgressiveImage-module--loaded--e7a39";
export var mainImage = "ProgressiveImage-module--mainImage--3a45a";